import { Box, CircularProgress } from '@mui/material';
import React from 'react';

export const GraphsLoader = ({ height = '825px' }: { height?: string }) => {
  return (
    <Box
      sx={{
        background: '#bab9b926',
        height,
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        borderRadius: '5px',
        zIndex: 2,
      }}
    >
      <Box sx={{ position: 'relative', top: '45%', left: '45%', width: 'fit-content' }}>
        <svg style={{ height: 0, width: 0 }}>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#0D2036" />
            <stop offset="100%" stopColor="#D9D9D9" />
          </linearGradient>
        </svg>
        <CircularProgress
          data-testid="circular-progress"
          sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}
          thickness={4}
          size={70}
        />
      </Box>
    </Box>
  );
};
